module.exports = {"author":"yamadapc","permlink":"test-1-2-3-4-5-6-7-9","category":"test","parent_author":"","parent_permlink":"test","title":"test-1-2-3-4-5-6-7-9","body":"<script>alert('hello world')</script>","allow_replies":true,"allow_votes":true,"allow_curation_rewards":true,"url":"/test/@yamadapc/test-1-2-3-4-5-6-7-9"}


//////////////////
// WEBPACK FOOTER
// ./test/test-post.json
// module id = 287
// module chunks = 1